import { Deserializable } from '../protocols/deserializable';

export class TransactionStatus implements Deserializable {
  public id!: number;
  public name!: string;

  onDeserialize() {}
}
